import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import moment from "moment"
import React, { Component } from 'react'
import { SingleDatePicker } from "react-dates"
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import GlobalHelper from "../common/GlobalHelper.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import Checkbox from "../common/checkbox/checkbox.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import StandardList from "../common/listing/list.component.jsx"
import CommitmentDurationInput from "../common/pricing/commitmentdurationinput.component.jsx"
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import InputUnitOfMeasure from "../common/unit-of-measure/input.component.jsx"
import CustomerSelect from "../customer/selection.component.jsx"
import LocationSelect from "../location/locationselect.component.jsx"
import PaymentTermSelect from '../payment-term/locationselect.component.jsx'
import ContactService from '../state/contact/services/index'
import { isBundle, isBundleItem } from "../utils"
class NewInvoiceModal extends Component {

    constructor(props, context) {
        super(props, context);

        const dueDate = moment();
        this.state = {
            modalId: this.props.modalId || 'invoice-creation-modal',
            recurring: this.props.recurring || false,
            isReturn: this.props.isReturn || false,
            quoteId: this.props.quoteId || '',
            contactId: this.props.contactId || '',
            projectId: this.props.projectId || '',
            orderId: this.props.orderId || '',
            focused: false,
            dueDate: dueDate,
            sellerId: this.props.sellerId || AppContext.getUserLoggedIn().id,
            reference: {
                recurringItems: [],
                objectId: this.props.quoteId || '',
                type: 'quote',
                includeItems: true,
            },
            itemsListToInvoice: [],
            itemsToInvoice: [],
            existingInvoices: [],
            recurringItems: [],
            days: [7, 15, 30, 45],
            orderTotalAmount: '0',
            loading: false,
            hasPaymentTerms: false,
            checkAll: true,
            paymentTermId: '',
            groups: this.props.groups,
            locationId: this.props.locationId ? this.props.locationId : (AppContext.getUserLoggedIn().attributes.location?.id ?? ''),
            createInvoiceDisabled: true,
            priceListId: this.props.priceListId || '',
        }
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.saveInvoice = this.saveInvoice.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.loadPaymentTerm = this.loadPaymentTerm.bind(this)
        this.loadCustomer = this.loadCustomer.bind(this)
        this.onCheckAll = this.onCheckAll.bind(this)
        this.onItemChecked = this.onItemChecked.bind(this)
        this.onItemInputChange = this.onItemInputChange.bind(this)
        this.setLocation = this.setLocation.bind(this)
        this.fetchPaymentTerms = this.fetchPaymentTerms.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        this.setState({
            loading: true,
        })
        if (this.state.quoteId) {
            const itemsToInvoice = []
            Promise.all([
                AppContext.getApiClient().get('/quotes/' + this.state.quoteId),
                AppContext.getApiClient().get('/quotes/' + this.state.quoteId + '/invoices'),
            ]).then(res => {
                itemsToInvoice.push({
                    id: res[0].id,
                    type: 'quotes',
                    reference: res[0].attributes.identifier,
                    totalAmount: res[0].attributes.totalAmount,
                    currency: res[0].attributes.currency,
                    status: res[0].attributes.status,
                    updatedAt: res[0].attributes.updatedAt,
                    items: res[0].attributes.items,
                    totals: res[0].attributes.totals,
                })
                const ref = this.state.reference
                ref.includeItems = res[1].data.length === 0
                this.setState({
                    itemsToInvoice: itemsToInvoice,
                    existingInvoices: res[1].data,
                    loading: false,
                    reference: ref,
                })
            })
        }

        if (this.state.orderId) {
            AppContext.getApiClient().get(`/orders/${this.state.orderId}`).then(res => {
                let itemsListToInvoice = res.attributes.items.map(item => {
                    item.checked = true
                    item.attributes.measureToInvoice = parseFloat(item.attributes.totalMeasure) - parseFloat(item.attributes.invoicedMeasure)
                    if ((parseFloat(item.attributes.invoicedMeasure) >= parseFloat(item.attributes.totalMeasure))) {
                        item.disabled = true
                        item.checked = false
                    }
                    if (item.attributes.measureToInvoice < 0)
                        item.attributes.measureToInvoice = 0
                    if (item.attributes.totalMeasure <= 0) {
                        item.disabled = true
                        item.checked = false
                    }
                    item.attributes.maxMeasureInvoiced = item.attributes.measureToInvoice
                    return item
                })

                let createInvoiceDisabled = true
                for (let item of itemsListToInvoice) {
                    if (parseFloat(item.attributes.invoicedMeasure) < parseFloat(item.attributes.measure)) {
                        createInvoiceDisabled = false
                        break
                    }
                }

                itemsListToInvoice = itemsListToInvoice.filter(item => !isBundleItem(item))
                this.setState({
                    itemsListToInvoice,
                    loading: false,
                    createInvoiceDisabled: createInvoiceDisabled,
                })
            })
        }

        this.fetchPaymentTerms()
    }

    async fetchPaymentTerms() {
        const res = await AppContext.getApiClient().get('/payment-terms');
        const defaultAccountTerm = res.data.filter(t => t.attributes.isDefault)[0];

        this.setState({
            loading: false,
            hasPaymentTerms: res.data.length > 0,
        })

        if (this.state.contactId) {
            const primaryContact = await ContactService.GetPrimaryContactFromCompany(this.state.contactId);
            const paymentTermId = primaryContact.getPaymentTermId();
            const companyId = primaryContact.getCompanyId();

            if (paymentTermId) {
                this.setState({ loading: false })
                this.loadPaymentTerm(paymentTermId)
                return
            }
            if (companyId) {
                const organization = await ContactService.Get(companyId)
                const orgPaymentTermId = organization.getPaymentTermId()

                if (orgPaymentTermId) {
                    this.loadPaymentTerm(orgPaymentTermId)
                    return
                }
            }

            this.loadPaymentTerm(defaultAccountTerm?.id);
        } else {
            this.loadPaymentTerm(defaultAccountTerm?.id);
        }
    }


    loadPaymentTerm(paymentTermId) {
        if (!paymentTermId) {
            this.setState({
                paymentTermId: paymentTermId,
            })
            return
        }
        AppContext.getApiClient().post('/payment-terms/' + paymentTermId + '/evaluate', {
            issuedDate: new Date().toISOString()
        }).then(res => {
            this.setState({
                paymentTermId: paymentTermId,
                dueDate: moment(res.attributes.dueDate),
            })
        })
    }

    loadCustomer(contactId) {
        if (!contactId) {
            return
        }
        this.setState({
            contactId: contactId
        })
        ContactService.Get(contactId).then(con => {
            if (con.getPaymentTermId()) {
                this.setState({
                    loading: false,
                })
                this.loadPaymentTerm(con.getPaymentTermId())
            } else if (con.getCompanyId()) {
                ContactService.Get(con.getCompanyId()).then(org => {
                    if (org.getPaymentTermId()) {
                        this.loadPaymentTerm(org.getPaymentTermId())
                    }
                })
            }
        })
    }

    handleCloseModal(event) {
        event.preventDefault()
        this.closeModal()
    }

    closeModal(invoiceId) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(invoiceId)
        }
    }

    today() {
        const newDate = moment().toDate()
        newDate.setHours(0, 0, 0, 0)
        return newDate.toISOString()
    }

    saveInvoice(event) {
        event.preventDefault()
        if (this.state.priceListId) {
            AppContext.getApiClient().post('/price-lists/' + this.state.priceListId + '/invoice', {
                sellerId: this.state.sellerId,
                contactId: this.state.contactId,
                paymentTermId: this.state.paymentTermId,
                billingType: 'one-time',
                locationId: this.state.locationId,
                dueDate: this.state.dueDate.format(),
                priceListId: this.state.priceListId,
            }).then(inv => {
                this.closeModal(inv.id)
            })
            return
        }

        const data = {
            sellerId: this.state.sellerId,
            projectId: this.state.projectId,
            contactId: this.state.contactId,
            paymentTermId: this.state.paymentTermId,
            reference: this.state.reference,
            billingType: 'one-time',
            locationId: this.state.locationId,
        }
        if (this.state.recurring) {
            data.recurringInfo = {
                sendEmail: false,
                capturePayment: false,
                createDaysInAdvance: 0,
                intervalType: 'monthly',
                interval: 1,
                month: 1,
                endingType: 'never',
            }
            data.billingType = 'recurring'
        } else {
            data.dueDate = this.state.dueDate.format()
        }

        // duplicating an invoice
        if (this.props.fromProjectId && this.props.fromInvoiceId) {
            const duplicateEndpoint = `/invoices/${this.props.fromInvoiceId}/duplicate`
            AppContext.getApiClient()
                .post(duplicateEndpoint, data)
                .then(invoice => {
                    this.closeModal(invoice.id)
                })
            return
        }

        if (this.state.isReturn) {
            data.billingType = 'return'
        }
        if (this.state.orderId) {
            data.reference = {
                objectId: this.state.orderId,
                type: 'order'
            }
            data.rows = this.state.itemsListToInvoice.filter(item => item.checked && parseFloat(item.attributes.measureToInvoice) > 0).map(item => {
                return {
                    referenceRowId: item.id,
                    measure: String(item.attributes.measureToInvoice),
                    productId: item.attributes.itemObject.id,
                    groupId: item.attributes.groupId,
                    status: item.attributes.type,
                }
            })
        }

        return AppContext.getApiClient().post('/invoices', data).then(inv => {
            this.closeModal(inv.id)
        })
    }

    hasSelectedItemsToBeInvoiced() {
        return this.state.itemsListToInvoice.filter(item => item.checked).length > 0
    }

    getDurationInvoiced(id, measure) {
        return this.state.existingInvoices.reduce((accumulator, inv) => {
            return inv.attributes.items.filter(r => r.attributes.referenceRowId === id).reduce((acc, row) => {
                return parseInt(parseFloat(row.attributes.measure) / measure) + acc
            }, 0) + accumulator
        }, 0)
    }

    handleFormChange(event) {
        const checked = event.target.checked
        const ref = this.state.reference
        ref.includeItems = checked
        this.setState({
            reference: ref
        })
    }

    changeDueDate(nbDays) {
        return function (e) {
            e.preventDefault()
            this.setState({
                dueDate: moment().add(nbDays, 'days')
            })
        }.bind(this)
    }

    modalTitle() {
        if (this.state.recurringInfo)
            return <FormattedMessage
                id="invoice.modal.creation.title_recurring"
                defaultMessage="Create a recurring invoice"
            />
        else if (this.state.isReturn)
            return <FormattedMessage
                id="invoice.modal.creation.title_return"
                defaultMessage="Create a return"
            />

        return <FormattedMessage
            id="invoice.modal.creation.title"
            defaultMessage="Create an invoice"
        />
    }

    onCheckAll(isChecked) {
        this.setState({
            checkAll: isChecked,
            itemsListToInvoice: this.state.itemsListToInvoice.map(item => {
                item.checked = !item.disabled ? isChecked : false
                item.attributes.measureToInvoice = isChecked ? item.attributes.maxMeasureInvoiced : 0
                return item
            })
        })
    }


    onItemChecked(item, isChecked) {
        item.checked = isChecked
        item.attributes.measureToInvoice =
            isChecked ? item.attributes.maxMeasureInvoiced : 0

        this.setState({
            itemsListToInvoice: [...this.state.itemsListToInvoice]
        })
    }

    onItemInputChange(item, val) {
        if (parseFloat(val) > item.attributes.maxMeasureInvoiced)
            val = item.attributes.maxMeasureInvoiced
        else if (parseFloat(val) < 1)
            val = 1

        item.attributes.measureToInvoice = val
        this.setState({
            itemsListToInvoice: [...this.state.itemsListToInvoice]
        })
    }

    setLocation(locationId) {
        this.setState({
            locationId: locationId,
        })
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="invoice.modal.creation.product_name_label"
                defaultMessage="Product name"
            />,
            <FormattedMessage
                id="invoice.modal.creation.quantity_sold_label"
                defaultMessage="Quantity sold"
            />,
            <FormattedMessage
                id="invoice.modal.creation.quantity_already_invoiced_label"
                defaultMessage="Already invoiced"
            />]

        if (AppContext.hasFeatureIntegration(Features.InventorySync)) {
            headers = [
                ...headers,
                <FormattedMessage
                    id="invoice.modal.creation.qty_in_stock_label"
                    defaultMessage="Quantity in stock"
                />]
        }

        return [...headers,
        <FormattedMessage
            id="invoice.modal.creation.quantity_to_be_invoiced_label"
            defaultMessage="To be invoiced"
        />,
        <Checkbox id={'check-all'}
            checked={this.state.checkAll}
            onChange={isChecked => this.onCheckAll(isChecked)} />]
    }
    row(item) {
        let row = [
            <div className="text-break">
                {item.attributes.activeTitle}
            </div>,

            <div className="text-center">
                {item.attributes.totalMeasure}
            </div>,

            <div className="text-center">
                {item.attributes.invoicedMeasure}
            </div>
        ]

        if (AppContext.hasFeatureIntegration(Features.InventorySync)) {
            row = [...row, <div className="text-center">
                {item.attributes.itemObject.attributes.quantityOnHand}
            </div>]
        }

        const data = [...row,
        <div className="input-group m-1">
            <InputUnitOfMeasure
                disabled={item.disabled || isBundle(item)}
                debounced={true}
                value={item.attributes.measureToInvoice}
                unit={item.attributes.unitOfMeasure}
                onChange={val => this.onItemInputChange(item, val)}
                format={'short'}
            />
        </div>,
        !item.disabled ? <Checkbox id={'returned-item-' + item.id}
            checked={item.checked}
            onChange={isChecked => this.onItemChecked(item, isChecked)}
            style={{ top: 0 }} /> : ''
        ]

        let rowClassNames = []
        for (const c of data) {
            rowClassNames.push('px-4 py-2')
        }
        // Change style for measure column
        rowClassNames[rowClassNames.length - 2] = 'col-xs-4 col-sm-3 col-lg-2 px-0 py-2'
        return {
            data: data,
            classNames: rowClassNames,
        }
    }

    getWarningMessage() {
        switch (this.props.warningMessage) {
            case ('invoicing_price_list_warning'):
                return <FormattedMessage
                    id="invoice.modal.creation.invoicing_price_list_warning_message"
                    defaultMessage="Any further modification to this price list will not be possible after this point."
                />
        }
    }

    render() {
        let content = <p />
        if (this.state.loading) {
            content = <LoadingSpinner className="py-2" />
        }
        if (!this.state.loading && this.state.orderId) {
            content = <div className="w-100">
                <StandardList
                    className="row"
                    headers={this.headers()}
                    rows={this.state.itemsListToInvoice.sort((item1, item2) => GlobalHelper.compareItemsByGroupAndRank(item1, item2, this.state.groups)).map(item => this.row(item))}
                    rowClassName={" "}
                    smallLine={true}
                />
            </div>
        }
        if (!this.state.loading && this.state.quoteId) {
            content = this.state.itemsToInvoice.map((item, index) => {
                let classes = "form-group row pt-3"
                if (index !== 0) {
                    classes = classes + " border-top"
                }
                const billingMethods = GlobalHelper.unique(item.items.map(r => r.attributes.billingMethod))

                return <div className={classes} key={item.id}>
                    {item.totals.filter(t => billingMethods.includes(t.attributes.billingMethod)).map(t => {
                        if (t.attributes.billingMethod === "one-time") {
                            return <div className="col-12 py-2" key={item.id + "-one-time"}>
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox"
                                        className="custom-control-input"
                                        id={item.id}
                                        value={item.id}
                                        name={item.type}
                                        checked={this.state.reference.includeItems}
                                        onChange={this.handleFormChange}
                                    />
                                    <label className="custom-control-label" htmlFor={item.id}>
                                        <FormattedMessage
                                            id="invoice.modal.creation.include_number_lines_label"
                                            defaultMessage="{number, plural, one {Include # line} other {Include # lines}}"
                                            values={{
                                                number: item.items.filter(r => r.attributes.billingMethod === "one-time" && !isBundleItem(r)).length
                                            }}
                                        />
                                        &nbsp;-&nbsp;
                                        <FormattedNumber
                                            style="currency"
                                            currency={t.attributes.currency}
                                            value={t.attributes.totalAmount}
                                        />
                                    </label>
                                </div>
                            </div>
                        } else {

                            let label = <FormattedMessage
                                id="common.billing_method.label.monthly_recurring"
                                defaultMessage="Monthly recurring"
                            />
                            if (t.attributes.billingMethod === "yearly") {
                                label = <FormattedMessage
                                    id="common.billing_method.label.yearly_recurring"
                                    defaultMessage="Yearly recurring"
                                />
                            }
                            const methodItems = item.items.filter(r => r.attributes.billingMethod === t.attributes.billingMethod).filter(r => {
                                if (!r.attributes.commitmentDuration) {
                                    return true
                                }
                                const durationToInvoice = r.attributes.commitmentDuration - this.getDurationInvoiced(r.id, r.attributes.measure)
                                if (durationToInvoice <= 0) {
                                    return false
                                }
                                return true
                            })
                            return <div className={"col-12"}>
                                <div className={"row"}>{[
                                    methodItems.length > 0 ?
                                        <div className="col-12" key={t.attributes.billingMethod}><u>{label}</u>
                                        </div> : '',
                                    methodItems.map(r => {
                                        const durationToInvoice = r.attributes.commitmentDuration - this.getDurationInvoiced(r.id, r.attributes.measure)
                                        let labelLeft = <FormattedMessage
                                            id="invoice.modal.creation.month_left_label"
                                            defaultMessage="{duration, plural, one {# month left} other {# months left}}"
                                            values={{
                                                duration: durationToInvoice
                                            }}
                                        />
                                        if (t.attributes.billingMethod === "yearly") {
                                            labelLeft = <FormattedMessage
                                                id="invoice.modal.creation.year_left_label"
                                                defaultMessage="{duration, plural, one {# year left} other {# years left}}"
                                                values={{
                                                    duration: durationToInvoice
                                                }}
                                            />
                                        }
                                        if (!r.attributes.commitmentDuration) {
                                            labelLeft = <FormattedMessage
                                                id="invoice.modal.creation.unlimited_label"
                                                defaultMessage="Unlimited"
                                            />
                                        }
                                        const recurringItem = this.state.reference.recurringItems.filter(i => i.rowId === r.id)[0]
                                        return <div className="col-12 d-flex justify-content-between pt-1" key={r.id}>
                                            <div>
                                                <p className="m-0">{r.attributes.itemObject.attributes.title}</p>
                                                <p className="m-0 pb-1"><small>{labelLeft}</small></p>
                                            </div>
                                            <p className="m-0 col-4 px-0 py-2">
                                                <CommitmentDurationInput
                                                    value={recurringItem ? recurringItem.duration : ''}
                                                    className={"input-group-sm"}
                                                    billingMethod={r.attributes.billingMethod}
                                                    name={r.id}
                                                    onChange={val => {
                                                        if (val > durationToInvoice && r.attributes.commitmentDuration) {
                                                            return
                                                        }
                                                        let items = this.state.reference.recurringItems
                                                        if (items.filter(i => i.rowId === r.id).length) {
                                                            items = items.map(i => {
                                                                if (r.id === i.rowId) {
                                                                    i.duration = parseInt(val)
                                                                }
                                                                return i
                                                            })
                                                        } else {
                                                            items.push({
                                                                rowId: r.id,
                                                                duration: parseInt(val),
                                                            })
                                                        }
                                                        const ref = this.state.reference
                                                        ref.recurringItems = items
                                                        this.setState({
                                                            reference: ref
                                                        })
                                                    }}
                                                />
                                            </p>
                                        </div>
                                    }),
                                ]}</div>
                            </div>
                        }
                    })}
                </div>
            })
        }

        return (
            <form className="needs-validation" noValidate id="work-order-form-creation-modal">
                <div className="modal"
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className={"modal-dialog " + (this.state.orderId ? 'modal-lg' : 'modal-signature')}
                        role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title h5" id={this.state.modalId + "Label"}>
                                    {this.modalTitle()}
                                </div>
                            </div>
                            <div className="modal-body py-0">
                                {this.props.warningMessage &&
                                    <div className="mt-2">
                                        <div className="col-12 alert alert-warning ">
                                            <small>
                                                {this.getWarningMessage()}
                                            </small>
                                        </div>
                                    </div>
                                }
                                {!this.state.loading ? <div className="container-fluid">
                                    <div className="form-group row mt-3">
                                        <label htmlFor="contactId" className="col-lg-3 col-12 col-form-label">
                                            {this.state.isReturn ? <FormattedMessage
                                                id="common.invoice.modal.customer_return_label"
                                                defaultMessage="Return for"
                                            /> : <FormattedMessage
                                                id="common.invoice.modal.customer_label"
                                                defaultMessage="Invoice to"
                                            />}
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <CustomerSelect
                                                id={'contactId'}
                                                contactType={'persons'}
                                                value={this.state.contactId}
                                                onChange={this.loadCustomer}
                                            />
                                        </div>
                                    </div>
                                    {AppContext.isMultiLocation() &&
                                        <div className="form-group row mt-3">
                                            <label htmlFor="locationId" className="col-lg-3 col-12 col-form-label">
                                                <FormattedMessage
                                                    id="common.invoice.modal.location_label"
                                                    defaultMessage="Location"
                                                />
                                            </label>
                                            <div className="col-lg-9 col-12">
                                                <LocationSelect
                                                    value={this.state.locationId}
                                                    onChange={this.setLocation}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {this.state.hasPaymentTerms && !this.state.isReturn ?
                                        <div className="form-group row mb-2">
                                            <label className="col-lg-3 col-12 col-form-label">
                                                <FormattedMessage
                                                    id="common.invoice.modal.payment_terms_label"
                                                    defaultMessage="Payment term"
                                                />
                                            </label>
                                            <div className="col-lg-9 col-12">
                                                <div className={'mb-2'}>
                                                    <PaymentTermSelect
                                                        value={this.state.paymentTermId}
                                                        onChange={this.loadPaymentTerm}
                                                    />
                                                </div>
                                            </div>
                                        </div> : null}
                                    {(!this.state.recurring && !this.state.isReturn) ?
                                        <div className="form-group row mb-0">
                                            <label htmlFor="dueDate" className="col-lg-3 col-12 col-form-label">
                                                <FormattedMessage
                                                    id="common.invoice.modal.due_date_label"
                                                    defaultMessage="Due date"
                                                />
                                            </label>
                                            <div className="col-lg-9 col-12">
                                                <div className={'mb-2'}>
                                                    <SingleDatePicker
                                                        small
                                                        block
                                                        displayFormat="LL"
                                                        isOutsideRange={() => false}
                                                        focused={this.state.focused}
                                                        onDateChange={(date) => {
                                                            this.setState({
                                                                dueDate: date
                                                            })
                                                        }}
                                                        onFocusChange={({ focused }) => this.setState({ focused })}
                                                        date={this.state.dueDate}
                                                        numberOfMonths={1}
                                                        id={'dueDate'}
                                                    />
                                                </div>
                                                {!this.state.hasPaymentTerms ? <div className={'mb-0'}>
                                                    {this.state.days.map(d => {
                                                        return <button key={d} className={'btn btn-sm btn-light mr-2'}
                                                            onClick={this.changeDueDate(d)}>
                                                            <Icon value={'calendar-check'} className={'mr-1'} />
                                                            <FormattedMessage
                                                                id="common.invoice.modal.nb_days"
                                                                defaultMessage="{nbDays} days"
                                                                values={{
                                                                    nbDays: d
                                                                }}
                                                            />
                                                        </button>
                                                    })}
                                                </div> : null}
                                            </div>
                                        </div> : ''}
                                    {content}
                                </div> : <div className="container-fluid">
                                    <LoadingSpinner className="py-2" />
                                </div>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.handleCloseModal}>
                                    <FormattedMessage
                                        id="common.invoice.modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                {this.state.isReturn ?
                                    <ActionButton disabled={this.state.contactId === ''} className="btn btn-warning"
                                        onClick={this.saveInvoice}>
                                        <Icon value={"undo"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="common.invoice.modal.return_confirm_btn"
                                            defaultMessage="Create return"
                                        />
                                    </ActionButton> :
                                    <ActionButton
                                        disabled={
                                            this.state.contactId === '' ||
                                            (this.state.orderId && (!this.hasSelectedItemsToBeInvoiced() || this.state.createInvoiceDisabled))
                                        }
                                        className="btn btn-primary"
                                        onClick={this.saveInvoice}>
                                        <Icon value={"invoice"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="common.invoice.modal.confirm_btn"
                                            defaultMessage="Create invoice"
                                        />
                                    </ActionButton>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(NewInvoiceModal)





// WEBPACK FOOTER //
// ./src/invoice/newmodal.component.jsx